// extracted by mini-css-extract-plugin
export default {"background":"Send_background__n8739","body":"Send_body__Lb3Vz","footerNames":"Send_footerNames__oJvTt","sendButton":"Send_sendButton__gH25C","friendsList":"Send_friendsList__zUiOD"};